import { useState } from "react";
import { useNavigate } from "@usas/ui-web/wrappers/ReactRouterDom";

import NavLinks from "../../NavLinks";

import useGroupData from "@usas/ui-web/state/group/UseGroupData";
import useMemberGroupsData from "@usas/ui-web/state/memberGroups/UseMemberGroupsData";

const INITIAL_STATE = {
  displayDeletePopup: false,
  displayWorkflowPopup: false,
  deleteMemberObj: {},
  workflowMemberObj: {}
};

const useGroupSAAMembers = () => {
  const navigate = useNavigate();
  const { groupState, groupMembersState, getGroupMembers } = useGroupData();
  const { memberGroupsState, deleteGroupMember, resetMemberGroupsState } = useMemberGroupsData();
  const [state, setState] = useState(INITIAL_STATE);

  const onInviteAlternateClicked = () => {
    navigate(NavLinks.GROUP_MEMBERS_INVITE_ALTERNATE);
  };

  const onAddMemberToGroupClicked = () => {
    navigate(NavLinks.GROUP_MEMBERS_ADD);
  };

  const onEditGroupMemberClicked = (event, member) => {
    event?.preventDefault();

    navigate(NavLinks.GROUP_MEMBERS_EDIT, { state: { member } });
  };

  const onEditGroupMemberStatusClicked = (event, member) => {
    event?.preventDefault();

    setState({
      ...state,
      displayWorkflowPopup: true,
      workflowMemberObj: member
    });
  };

  const onDeleteModalConfirmClicked = async (event) => {
    event?.preventDefault();

    const personOrgGroupId = state.deleteMemberObj.personOrgGroupId;

    setState({
      ...state,
      displayDeletePopup: false,
      deleteMemberObj: {}
    });

    const deleteGroupMemberResult = await deleteGroupMember(personOrgGroupId);

    if (deleteGroupMemberResult) {
      resetMemberGroupsState();

      await getGroupMembers(groupState.objData.orgGroupId, true);
    }
  };

  const onDeleteGroupMemberClicked = (event, member) => {
    event?.preventDefault();

    setState({
      ...state,
      displayDeletePopup: true,
      deleteMemberObj: member
    });
  };

  const onModalCancelClicked = (event, refreshGrid = false) => {
    event?.preventDefault();

    if (refreshGrid === true) {
      getGroupMembers(groupState.objData.orgGroupId, true);
    }

    setState({
      ...state,
      displayDeletePopup: false,
      displayWorkflowPopup: false,
      deleteMemberObj: {},
      workflowMemberObj: {}
    });
  };

  return {
    isLoading: groupMembersState.isArrayLoading,
    isSaving: memberGroupsState.isSaving,
    gridData: groupMembersState.arrayData || [],
    state,
    onInviteAlternateClicked,
    onAddMemberToGroupClicked,
    onEditGroupMemberClicked,
    onEditGroupMemberStatusClicked,
    onDeleteGroupMemberClicked,
    onDeleteModalConfirmClicked,
    onModalCancelClicked
  };
};

export default useGroupSAAMembers;